import ApiUtils from "../ApiUtils";

export default class ApiStudentActivityService {

    async getLoginCount(type) {
        return await ApiUtils.callApi(`dashboard/student/logindetails/${type}`,'get');
    }
}
